export function initCustomCursor(selector) {
  const section = document.querySelector(selector);
  if (!section) return;

  const cursorEl = document.createElement('div');
  cursorEl.classList.add('custom-cursor');
  cursorEl.style.cssText = `
    position: fixed;
    pointer-events: none;
    z-index: 9;
    width: 116px;
    height: 116px;
    background: url('${themeUrl}/src/img/cursor.svg') no-repeat center/contain;
    transform: translate(-50%, -50%);
    display: none;
  `;
  document.body.appendChild(cursorEl);

  let isInside = false;

  function isWithinBounds(e) {
    const rect = section.getBoundingClientRect();
    return (
      e.clientX >= rect.left &&
      e.clientX <= rect.right &&
      e.clientY >= rect.top &&
      e.clientY <= rect.bottom
    );
  }

  function showCursor() {
    if (!isInside) {
      isInside = true;
      section.style.cursor = 'none';
      cursorEl.style.display = 'block';
    }
  }

  function hideCursor() {
    if (isInside) {
      isInside = false;
      section.style.cursor = '';
      cursorEl.style.display = 'none';
    }
  }

  document.addEventListener('mousemove', (e) => {
    if (isWithinBounds(e)) {
      showCursor();
      cursorEl.style.left = e.clientX + 'px';
      cursorEl.style.top = e.clientY + 'px';
    } else {
      hideCursor();
    }
  });
}
